module.exports = __webpack_public_path__ + "media/application/images/logo-bee768072995c375159c0643e03dbc63.jpg";